import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import Dialog from "rc-dialog";

import {
  StyledCookieMessageAction,
  StyledCookieMessageContainer,
  StyledCookieMessageContent,
  StyledCookieMessageWrapper,
  StyledCookiePreference,
  StyledCookiePreferenceWrapper
} from "./styled-cookies-message";
import { StyledButton } from "../styles/styledButton";
import Switch from "rc-switch";

const CookiesMessage = ({ cookie, setCookie }) => {
  const [visible, setVisible] = useState(false);

  const savePreference = () => {
    Cookies.set("useCookiesConsent", JSON.stringify(cookie), { expires: 365 });
    setVisible(false);
  };

  const saveAll = () => {
    for (let option in cookie) {
      setCookie((prevState) => ({ ...prevState, option: true }));
    }

    Cookies.set("useCookiesConsent", JSON.stringify(cookie), { expires: 365 });
    setVisible(false);
  };

  return (
    <>
      <Dialog
        visible={visible}
        wrapClassName="rc-modal-center cookie-preference-modal"
        closeIcon={false}
        closable={false}
        animation="zoom"
        maskAnimation="fade"
        title="Cookie settings"
        className="default-modal"
      >
        <div className="default-modal__body-content">
          <StyledCookiePreferenceWrapper>
            <p>
              This website uses cookies to improve your experience while you navigate through the website. Out of these cookies, the cookies that are categorized as necessary are stored on your browser as they are essential for the working of basic functionalities of the website. We also use third-party cookies that help us analyze and understand how you use this website. These cookies will be stored in your browser only with your consent. You also have the option to opt-out of these cookies. But opting out of some of these cookies may have an effect on your browsing experience
            </p>
            <p>
              <NavLink
                to="/cookies-policy"
                target="_blank"
                className="default-link"
                rel="noreferrer"
              >
                Cookie Policy
              </NavLink>
            </p>
            <StyledCookiePreference>
              <div className="preference-item">
                <div className="preference-item__content">
                  <h5>
                    Strictly necessary cookies
                  </h5>
                  <p>
                    This is an integral part of the site, without which it cannot function. They do not require user consent and cannot be disabled.
                  </p>
                </div>
                <div className="preference-item__action readOnly">
                  <Switch
                    className="default-checkbox"
                    name="active"
                    checked={cookie.strictlyNecessary}
                    disabled
                  />
                </div>
              </div>
              <div className="preference-item">
                <div className="preference-item__content">
                  <h5>
                    Functionality cookies
                  </h5>
                  <p>
                    These are files that allow the site to remember the user's preferences and optimize its performance. They can save language, font, currency, and other settings that enhance the user experience. Functional cookies are not necessary for the operation of the site, but they can be useful to improve its functionality and usability.
                  </p>
                </div>
                <div className="preference-item__action">
                  <Switch
                    className="default-checkbox"
                    name="active"
                    checked={cookie.functional}
                    onChange={() => setCookie((prevState) => ({ ...prevState, functional: !cookie.functional }))}
                  />
                </div>
              </div>
              <div className="preference-item">
                <div className="preference-item__content">
                  <h5>
                    Performance cookies
                  </h5>
                  <p>
                    These are files that help collect information about how the site works and how it can be improved. They collect data about the user's interaction with the site, such as page load time and frequency of visits.
                  </p>
                </div>
                <div className="preference-item__action">
                  <Switch
                    className="default-checkbox"
                    name="active"
                    checked={cookie.performance}
                    onChange={() => setCookie((prevState) => ({ ...prevState, performance: !cookie.performance }))}
                  />
                </div>
              </div>
              <div className="preference-item">
                <div className="preference-item__content">
                  <h5>
                    Targeting cookies
                  </h5>
                  <p>
                    These are files that are used to display advertisements on the site that are relevant to the user's interests. They may collect information about ad views and visits to advertising sites in order to provide ads that are most relevant to the user's interests.
                  </p>
                </div>
                <div className="preference-item__action">
                  <Switch
                    className="default-checkbox"
                    name="active"
                    checked={cookie.targeting}
                    onChange={() => setCookie((prevState) => ({ ...prevState, targeting: !cookie.targeting }))}
                  />
                </div>
              </div>
            </StyledCookiePreference>
          </StyledCookiePreferenceWrapper>
        </div>
        <div className="default-modal__body-footer">
          <StyledButton
            weight="normal"
            onClick={savePreference}
          >
            Save settings
          </StyledButton>
          <StyledButton
            color="main"
            weight="normal"
            onClick={saveAll}
          >
            Accept all
          </StyledButton>
        </div>
      </Dialog>
      {!cookie.agree &&
        <StyledCookieMessageWrapper>
          <StyledCookieMessageContainer>
            <StyledCookieMessageContent>
              <h4>
                How we use cookies
              </h4>
              <p>
                We use our own cookies as well as third party cookies on our websites to improve your experience, analyze our traffic, and improve security and marketing. Select "Accept all" to allow them to be used.
              </p>
              <NavLink
                to="/cookies-policy"
                target="_blank"
                className="default-link"
                rel="noreferrer"
              >
                Cookie Policy
              </NavLink>
            </StyledCookieMessageContent>
            <StyledCookieMessageAction>
              <StyledButton
                color="main"
                weight="normal"
                onClick={saveAll}
              >
                Accept all
              </StyledButton>
              <StyledButton
                weight="normal"
                onClick={() => {
                  setVisible(!visible);
                  setCookie((prevState) => ({ ...prevState, agree: true }));
                }}
              >
                Manage cookies
              </StyledButton>
            </StyledCookieMessageAction>
          </StyledCookieMessageContainer>
        </StyledCookieMessageWrapper>
      }
    </>
  );
};

export default CookiesMessage;
